import React from 'react';
import ReactDOM from 'react-dom/client';
import App from 'App';

// Import CSS.
import 'index.css';

// Render the app.
ReactDOM.createRoot(document.getElementById('root')).render(<App />);
